export const min = (a: number, b: number) => {
    return a < b ? a : b;
}

export const anyTrueToBoolean = (anyTrue: string): boolean => {
    return ['true', '1', 'yes', 'on'].includes(anyTrue.toLowerCase())
}